import { createContext, Dispatch, useContext, useMemo } from 'react';
import {
  ProductStyleAction,
  ProductStyleState,
  useProductStyleSwitcherState,
} from './useProductStyleSwitcherState';
import {
  ProductStyleData,
  UseProductStyleDataResult,
} from './useProductSwitchData';

interface ProductStyleContextData extends UseProductStyleDataResult {
  currentProductStyle: ProductStyleData;
  artistName: string;
  matureContent?: boolean;
}
interface ContextValue {
  state: ProductStyleState;
  dispatch: Dispatch<ProductStyleAction>;
  data: ProductStyleContextData;
}
interface ProductStyleProviderProps {
  children: React.ReactNode;
  data: ProductStyleContextData;
}

export const ProductStyleContext = createContext<ContextValue | undefined>(
  undefined
);
ProductStyleContext.displayName = 'ProductStyleContext';

export function ProductStyleProvider({
  children,
  data,
}: ProductStyleProviderProps) {
  const [state, dispatch] = useProductStyleSwitcherState();

  const value = useMemo(() => {
    return { state, dispatch, data };
  }, [state, dispatch, data]);

  return (
    <ProductStyleContext.Provider value={value}>
      {children}
    </ProductStyleContext.Provider>
  );
}

export function useProductStyleContext() {
  const context = useContext(ProductStyleContext);

  if (context === undefined) {
    throw new Error(
      `useProductStyleContext must be used within a ProductStyleContext Provider`
    );
  }

  return context;
}
